/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useCallback } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { connect } from "react-redux";
import { Form, Input, Checkbox, Modal } from 'antd';
import { useGoogleReCaptcha, GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { actions } from "../../store/reducers/authentication";
import { getRedirectPath } from "../../constants/user";
import { useTranslation } from "react-i18next";
import DemoView from './demo';
import Button from '../../components/Button';
import OnlyDesktop from "../OnlyDesktop";
import AuthLayout from "../../components/Layout/AuthLayout";
import Redirect from "../../components/Redirect";
import { useFirebase } from "../../components/Notifications/useFirebase";

const mstp = ({ authentication }) => ({ authentication });
const demo = process.env.REACT_APP_ENV === 'demo';
const step = 1;

const LoginComponent = ({
  authentication: { authenticated, loggingIn, errors, user, registerLoading },
  login,
  demoSignup,
  isAppInvitation,
  app = 'mmt',
}) => {
  const { t } = useTranslation();
  const location = useLocation();
  const [form] = Form.useForm();
  const [formErrors, setFormErrors] = useState(null);
  const { firebaseToken } = useFirebase();


  const { executeRecaptcha } = useGoogleReCaptcha();

  const handleReCaptchaVerify = useCallback(async () => {
    if (!executeRecaptcha) {
      console.log('Execute recaptcha not yet available');
      return;
    }

    const token = await executeRecaptcha('submit');
    return token;
  }, [executeRecaptcha]);

  useEffect(() => {
    setFormErrors(errors);
  }, [errors]);

  const isSM = () => false;

  const renderErrors = (err, t) => {
    document.querySelectorAll('.ant-form-item')
      .forEach(input => input.classList.add('ant-form-item-has-error'))
    return Object.keys(err).map(key => {
      return err[key].map(error =>
        <div
          className="ant-form-item-explain errors-cont"
          style={{ color: '#ff4d4f' }}>
          {t(error)}
        </div>
      )
    });
  }

  const loginHandle = async () => {
    const token = await handleReCaptchaVerify();

    if (token) {
      setFormErrors(null);
      form.validateFields().then(payload => {
        login({ ...payload, firebaseToken });
      });
    }
  }

  const getResetPassLink = () => {
    if (app === 'mmt') {
      return "/password/reset"
    }
    return `/${app}/password/reset`;
  }

  const getSignUpLink = () => {
    if (app === 'mmt') {
      return "/register"
    }

    return `/${app}/register`;
  }

  // const query = queryString.parse(location.search.replace('?', ''));
  const query = new URLSearchParams(location.search);
  const redirectPath = user ? getRedirectPath(user, query && query.get('fallback') ? query.get('fallback') : '', app) : '';
  const approved = query.get('approved') === 'true';

  return authenticated ? (
    isSM() && redirectPath !== '/app/admin' ? <OnlyDesktop /> : <Redirect to={redirectPath} />
  ) : demo && location.pathname !== '/admin/login' ? (
    <DemoView
      t={t}
      registerLoading={registerLoading}
      renderErrors={renderErrors}
      errors={errors}
      onSubmit={(payload, callback = () => { }) => demoSignup(payload, ({ approved }) => {
        Modal.info({
          title: 'Demo Access',
          content: (
            <div>
              <br></br>
              Thank you, <strong>{payload.firstName} {payload.lastName}</strong>.
              <br></br>
              {!approved && <>
                Your application is under review.
                <br></br>
              </>
              }
              A demo link will be sent to your email (<strong>{payload.email}</strong>){!approved && ' upon approval'}.
              <br></br>
              <br></br>
              If you have any question, you can also contact us at <a href="mailto:support@datastake.io" style={{ marginBottom: '20px' }}>support@datastake.io</a>
            </div>
          ),
          onOk: callback
        });
      })} />
  ) : (
    <AuthLayout
      step={step}
      title={approved ? 'Thank you!' : 'Welcome Back'}
      subTitle={approved ? 'Now you can proceed and log in.' : 'Welcome Back! Please enter your details.'}
      app={app}
    >
      <>
        <Form name="login" layout="vertical" form={form} initialValues={{ remember: true }}>
          <Form.Item
            required
            name="username"
            label={t("Email")}
            rules={[
              {
                required: true,
                message: t("errors::email should not be empty")
              },
              {
                pattern: /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                message: t('errors::email is not valid'),
              },
            ]}>
            <Input
              type="email"
              size="large"
              placeholder={t("Enter your email")}
              className="email"
              onPressEnter={loginHandle}
            />
          </Form.Item>
          <Form.Item
            required
            name="password"
            label={t("Password")}
            rules={[{
              required: true,
              message: t("errors::password should not be empty")
            }]}>
            <Input.Password
              type="password"
              size="large"
              className="password"
              placeholder="••••••••"
              onPressEnter={loginHandle}
            />
          </Form.Item>
          <Form.Item name="remember" valuePropName="checked" noStyle style={{ width: '100%' }}>
            <div style={{ display: 'flex', wdith: '100%' }}>
              <div style={{ flex: 1 }}>
                <Checkbox defaultChecked>{t("Remember me")}</Checkbox>
              </div>
              <Link to={getResetPassLink()}>
                {t('Reset Password')}
              </Link>
            </div>
          </Form.Item>
        </Form>
        {formErrors ? (
          renderErrors(formErrors, t)
        ) : null}
        <div className="buttons">
          <Button onClick={loginHandle} type="primary" block className="normal-br">
            {loggingIn ? t("Logging-in") : t('Log in')}
          </Button>
        </div>
        <div className="bottom">
          <p>
            {t('Don’t have an account?')}
            {' '}
            <Link to={getSignUpLink()}>{t('Sign Up')}</Link>
          </p>
        </div>
      </>
    </AuthLayout>
  );
};

const MappedLogin = connect(mstp, actions)(LoginComponent);

export const AppLogin = () => {
  const { app } = useParams();

  if (app === 'tif') {
    return <Login app="tif" />
  }

  if (app === 'tazama') {
    return <Login app="tazama" />
  }

  return <Login />
};

export default function Login({ app, isAppInvitation }) {
  return (
    <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_RECAPTCHA_PUBLIC_KEY}>
      <MappedLogin app={app} isAppInvitation={isAppInvitation} />
    </GoogleReCaptchaProvider>
  );
}
